export default (function (value) {
  return value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isUndefined.js
// module id = x4Y+
// module chunks = 0